import React from 'react';

export type StatusVariant = 'success' | 'warning' | 'danger' | 'neutral' | 'info';

type Props = {
  variant: StatusVariant;
  children: React.ReactNode;
  title?: string;
  className?: string;
};

export function statusVariantForDelivery(status: string): StatusVariant {
  switch (status.toUpperCase()) {
    case 'SENT':
      return 'success';
    case 'FAILED':
      return 'danger';
    case 'SKIPPED':
      return 'warning';
    default:
      return 'neutral';
  }
}

export function statusVariantForLinkDisplay(status: string): StatusVariant {
  const s = status.toLowerCase();
  if (s === 'sent' || s === 'new') return 'success';
  if (s === 'failed') return 'danger';
  if (s === 'skipped') return 'warning';
  if (s === 'discovered' || s === 'discovered only') return 'info';
  return 'neutral';
}

export default function StatusBadge({ variant, children, title, className = '' }: Props) {
  return (
    <span
      className={`status-badge status-badge--${variant} ${className}`.trim()}
      title={title}
      role="status"
    >
      {children}
    </span>
  );
}

export function DeliveryStatusBadge({ status }: { status: string }) {
  return <StatusBadge variant={statusVariantForDelivery(status)}>{status}</StatusBadge>;
}

export function DiscoveredLinkStatusBadge({ isNew }: { isNew: boolean }) {
  return isNew ? (
    <StatusBadge variant="success" title="First time seen in this scrape window">
      NEW
    </StatusBadge>
  ) : (
    <StatusBadge variant="neutral" title="Previously discovered URL">
      DUPLICATE
    </StatusBadge>
  );
}
